module.exports = __webpack_public_path__ + "assets/experience--background.00eacf41.svg";